// Strategy Execution Module - Balanced Scorecard Mock Data

// BSC Perspectives (Standard Balanced Scorecard framework)
export const bscPerspectives = [
  { id: 'financial', name: 'Financial & Investments', icon: 'DollarSign', color: '#10b981', order: 1 },
  { id: 'customer', name: 'Customers & Stakeholders', icon: 'Users', color: '#3b82f6', order: 2 },
  { id: 'internal', name: 'Internal Process', icon: 'Settings', color: '#f59e0b', order: 3 },
  { id: 'learning', name: 'Organizational Capacity', icon: 'GraduationCap', color: '#8b5cf6', order: 4 }
];

// Sectors (grouping of companies)
export const mockSectors = [
  { id: 'sector-tech', name: 'Technology', icon: 'Cpu', color: '#6366f1' },
  { id: 'sector-marketing', name: 'Marketing & Media', icon: 'Megaphone', color: '#ec4899' },
  { id: 'sector-finance', name: 'Financial Services', icon: 'Landmark', color: '#10b981' }
];

// Corporate Functions
export const mockCorporateFunctions = [
  { id: 'func-hr', name: 'Human Resources', icon: 'Users', color: '#f59e0b' },
  { id: 'func-it', name: 'Information Technology', icon: 'Server', color: '#3b82f6' },
  { id: 'func-legal', name: 'Legal & Compliance', icon: 'Scale', color: '#6b7280' },
  { id: 'func-finance', name: 'Corporate Finance', icon: 'Calculator', color: '#10b981' }
];

// Map companies to sectors
export const companySectorMap = {
  'comp1': 'sector-tech',      // TechCorp Inc.
  'comp2': 'sector-marketing', // Marketing Pro
  'comp3': 'sector-finance',   // FinanceHub
  'comp4': 'sector-marketing'  // Creative Studios
};

// Strategic Objectives by Entity
export const mockObjectives = [
  // Enterprise Level Objectives
  {
    id: 'obj-ent-1',
    entityId: 'enterprise',
    entityType: 'enterprise',
    perspectiveId: 'financial',
    name: 'Maximize Shareholder Value',
    weight: 30,
    target: 15,
    actual: 12.5,
    unit: '%',
    status: 'on-track',
    trend: 'up'
  },
  {
    id: 'obj-ent-2',
    entityId: 'enterprise',
    entityType: 'enterprise',
    perspectiveId: 'financial',
    name: 'Revenue Growth',
    weight: 25,
    target: 1500,
    actual: 1380,
    unit: 'M',
    status: 'at-risk',
    trend: 'up'
  },
  {
    id: 'obj-ent-3',
    entityId: 'enterprise',
    entityType: 'enterprise',
    perspectiveId: 'customer',
    name: 'Customer Satisfaction',
    weight: 20,
    target: 90,
    actual: 87,
    unit: '%',
    status: 'on-track',
    trend: 'stable'
  },
  {
    id: 'obj-ent-4',
    entityId: 'enterprise',
    entityType: 'enterprise',
    perspectiveId: 'internal',
    name: 'Operational Excellence',
    weight: 15,
    target: 95,
    actual: 91,
    unit: '%',
    status: 'on-track',
    trend: 'up'
  },
  {
    id: 'obj-ent-5',
    entityId: 'enterprise',
    entityType: 'enterprise',
    perspectiveId: 'learning',
    name: 'Employee Engagement',
    weight: 10,
    target: 85,
    actual: 78,
    unit: '%',
    status: 'below-target',
    trend: 'down'
  },

  // TechCorp Inc. Objectives
  {
    id: 'obj-tc-1',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Revenue',
    weight: 20.5,
    target: 384.5,
    actual: 358.8,
    lastYearActual: 414.7,
    unit: 'M',
    status: 'at-risk',
    trend: 'down',
    bonus: 19.13
  },
  {
    id: 'obj-tc-2',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Gross Profit',
    weight: 10,
    target: 151.4,
    actual: 139.0,
    lastYearActual: 214.2,
    unit: 'M',
    status: 'at-risk',
    trend: 'down',
    bonus: 9.18
  },
  {
    id: 'obj-tc-3',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Operating Profit',
    weight: 24,
    target: 8.0,
    actual: 0.8,
    lastYearActual: 84.2,
    unit: 'M',
    status: 'critical',
    trend: 'down',
    bonus: 2.46
  },
  {
    id: 'obj-tc-4',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'customer',
    name: 'Customer Satisfaction Score',
    weight: 5,
    target: 90,
    actual: 87,
    lastYearActual: 85,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 4.5
  },
  {
    id: 'obj-tc-5',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'customer',
    name: 'Net Promoter Score',
    weight: 4,
    target: 70,
    actual: 65,
    lastYearActual: 62,
    unit: '',
    status: 'on-track',
    trend: 'up',
    bonus: 3.71
  },
  {
    id: 'obj-tc-6',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'internal',
    name: 'Project Delivery On-Time',
    weight: 11,
    target: 90,
    actual: 78,
    lastYearActual: 82,
    unit: '%',
    status: 'below-target',
    trend: 'down',
    bonus: 9.53
  },
  {
    id: 'obj-tc-7',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'internal',
    name: 'Process Efficiency',
    weight: 12,
    target: 85,
    actual: 80,
    lastYearActual: 75,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 11.29
  },
  {
    id: 'obj-tc-8',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'learning',
    name: 'Training Hours per Employee',
    weight: 10,
    target: 40,
    actual: 35,
    lastYearActual: 30,
    unit: 'hrs',
    status: 'on-track',
    trend: 'up',
    bonus: 8.75
  },
  {
    id: 'obj-tc-9',
    entityId: 'comp1',
    entityType: 'company',
    perspectiveId: 'learning',
    name: 'Employee Retention',
    weight: 3.5,
    target: 90,
    actual: 85,
    lastYearActual: 88,
    unit: '%',
    status: 'at-risk',
    trend: 'down',
    bonus: 3.31
  },

  // Marketing Pro Objectives
  {
    id: 'obj-mp-1',
    entityId: 'comp2',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Revenue',
    weight: 25,
    target: 120,
    actual: 115,
    lastYearActual: 100,
    unit: 'M',
    status: 'on-track',
    trend: 'up',
    bonus: 23.96
  },
  {
    id: 'obj-mp-2',
    entityId: 'comp2',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Operating Margin',
    weight: 20,
    target: 18,
    actual: 16.5,
    lastYearActual: 15,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 18.33
  },
  {
    id: 'obj-mp-3',
    entityId: 'comp2',
    entityType: 'company',
    perspectiveId: 'customer',
    name: 'Client Retention Rate',
    weight: 15,
    target: 95,
    actual: 92,
    lastYearActual: 90,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 14.53
  },
  {
    id: 'obj-mp-4',
    entityId: 'comp2',
    entityType: 'company',
    perspectiveId: 'internal',
    name: 'Campaign Success Rate',
    weight: 20,
    target: 80,
    actual: 85,
    lastYearActual: 75,
    unit: '%',
    status: 'exceeding',
    trend: 'up',
    bonus: 21.25
  },
  {
    id: 'obj-mp-5',
    entityId: 'comp2',
    entityType: 'company',
    perspectiveId: 'learning',
    name: 'Digital Skills Certification',
    weight: 20,
    target: 90,
    actual: 88,
    lastYearActual: 80,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 19.56
  },

  // FinanceHub Objectives
  {
    id: 'obj-fh-1',
    entityId: 'comp3',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Assets Under Management',
    weight: 30,
    target: 500,
    actual: 480,
    lastYearActual: 420,
    unit: 'M',
    status: 'on-track',
    trend: 'up',
    bonus: 28.8
  },
  {
    id: 'obj-fh-2',
    entityId: 'comp3',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Fee Income',
    weight: 25,
    target: 25,
    actual: 24,
    lastYearActual: 22,
    unit: 'M',
    status: 'on-track',
    trend: 'up',
    bonus: 24
  },
  {
    id: 'obj-fh-3',
    entityId: 'comp3',
    entityType: 'company',
    perspectiveId: 'customer',
    name: 'Client Satisfaction',
    weight: 15,
    target: 92,
    actual: 90,
    lastYearActual: 88,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 14.67
  },
  {
    id: 'obj-fh-4',
    entityId: 'comp3',
    entityType: 'company',
    perspectiveId: 'internal',
    name: 'Compliance Score',
    weight: 20,
    target: 100,
    actual: 98,
    lastYearActual: 97,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 19.6
  },
  {
    id: 'obj-fh-5',
    entityId: 'comp3',
    entityType: 'company',
    perspectiveId: 'learning',
    name: 'Regulatory Certifications',
    weight: 10,
    target: 100,
    actual: 100,
    lastYearActual: 95,
    unit: '%',
    status: 'exceeding',
    trend: 'stable',
    bonus: 10
  },

  // Creative Studios Objectives
  {
    id: 'obj-cs-1',
    entityId: 'comp4',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Revenue',
    weight: 25,
    target: 80,
    actual: 78,
    lastYearActual: 70,
    unit: 'M',
    status: 'on-track',
    trend: 'up',
    bonus: 24.38
  },
  {
    id: 'obj-cs-2',
    entityId: 'comp4',
    entityType: 'company',
    perspectiveId: 'financial',
    name: 'Project Profitability',
    weight: 20,
    target: 35,
    actual: 32,
    lastYearActual: 30,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 18.29
  },
  {
    id: 'obj-cs-3',
    entityId: 'comp4',
    entityType: 'company',
    perspectiveId: 'customer',
    name: 'Design Awards Won',
    weight: 15,
    target: 10,
    actual: 12,
    lastYearActual: 8,
    unit: '',
    status: 'exceeding',
    trend: 'up',
    bonus: 18
  },
  {
    id: 'obj-cs-4',
    entityId: 'comp4',
    entityType: 'company',
    perspectiveId: 'internal',
    name: 'Creative Quality Score',
    weight: 25,
    target: 90,
    actual: 92,
    lastYearActual: 88,
    unit: '%',
    status: 'exceeding',
    trend: 'up',
    bonus: 25.56
  },
  {
    id: 'obj-cs-5',
    entityId: 'comp4',
    entityType: 'company',
    perspectiveId: 'learning',
    name: 'Tool Proficiency',
    weight: 15,
    target: 85,
    actual: 82,
    lastYearActual: 78,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 14.47
  },

  // Corporate Function - HR
  {
    id: 'obj-hr-1',
    entityId: 'func-hr',
    entityType: 'function',
    perspectiveId: 'financial',
    name: 'Cost per Hire',
    weight: 20,
    target: 5000,
    actual: 4800,
    lastYearActual: 5500,
    unit: '$',
    status: 'exceeding',
    trend: 'up',
    bonus: 20.83
  },
  {
    id: 'obj-hr-2',
    entityId: 'func-hr',
    entityType: 'function',
    perspectiveId: 'customer',
    name: 'Employee Satisfaction',
    weight: 30,
    target: 85,
    actual: 82,
    lastYearActual: 78,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 28.94
  },
  {
    id: 'obj-hr-3',
    entityId: 'func-hr',
    entityType: 'function',
    perspectiveId: 'internal',
    name: 'Time to Fill Position',
    weight: 25,
    target: 30,
    actual: 35,
    lastYearActual: 42,
    unit: 'days',
    status: 'at-risk',
    trend: 'up',
    bonus: 21.43
  },
  {
    id: 'obj-hr-4',
    entityId: 'func-hr',
    entityType: 'function',
    perspectiveId: 'learning',
    name: 'HR Team Certifications',
    weight: 25,
    target: 100,
    actual: 95,
    lastYearActual: 90,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 23.75
  },

  // Corporate Function - IT
  {
    id: 'obj-it-1',
    entityId: 'func-it',
    entityType: 'function',
    perspectiveId: 'financial',
    name: 'IT Budget Utilization',
    weight: 20,
    target: 95,
    actual: 92,
    lastYearActual: 88,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 19.37
  },
  {
    id: 'obj-it-2',
    entityId: 'func-it',
    entityType: 'function',
    perspectiveId: 'customer',
    name: 'User Satisfaction',
    weight: 25,
    target: 90,
    actual: 88,
    lastYearActual: 85,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 24.44
  },
  {
    id: 'obj-it-3',
    entityId: 'func-it',
    entityType: 'function',
    perspectiveId: 'internal',
    name: 'System Uptime',
    weight: 35,
    target: 99.9,
    actual: 99.8,
    lastYearActual: 99.5,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 34.97
  },
  {
    id: 'obj-it-4',
    entityId: 'func-it',
    entityType: 'function',
    perspectiveId: 'learning',
    name: 'Security Certifications',
    weight: 20,
    target: 100,
    actual: 100,
    lastYearActual: 100,
    unit: '%',
    status: 'exceeding',
    trend: 'stable',
    bonus: 20
  },

  // Corporate Function - Legal & Compliance
  {
    id: 'obj-legal-1',
    entityId: 'func-legal',
    entityType: 'function',
    perspectiveId: 'financial',
    name: 'Legal Budget Efficiency',
    weight: 25,
    target: 90,
    actual: 88,
    lastYearActual: 85,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 24.44
  },
  {
    id: 'obj-legal-2',
    entityId: 'func-legal',
    entityType: 'function',
    perspectiveId: 'customer',
    name: 'Internal Client Satisfaction',
    weight: 20,
    target: 85,
    actual: 82,
    lastYearActual: 80,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 19.29
  },
  {
    id: 'obj-legal-3',
    entityId: 'func-legal',
    entityType: 'function',
    perspectiveId: 'internal',
    name: 'Compliance Score',
    weight: 35,
    target: 100,
    actual: 98,
    lastYearActual: 96,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 34.3
  },
  {
    id: 'obj-legal-4',
    entityId: 'func-legal',
    entityType: 'function',
    perspectiveId: 'learning',
    name: 'Regulatory Training Completion',
    weight: 20,
    target: 100,
    actual: 95,
    lastYearActual: 90,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 19
  },

  // Corporate Function - Corporate Finance
  {
    id: 'obj-cf-1',
    entityId: 'func-finance',
    entityType: 'function',
    perspectiveId: 'financial',
    name: 'Reporting Accuracy',
    weight: 30,
    target: 99,
    actual: 98.5,
    lastYearActual: 98,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 29.85
  },
  {
    id: 'obj-cf-2',
    entityId: 'func-finance',
    entityType: 'function',
    perspectiveId: 'customer',
    name: 'Stakeholder Satisfaction',
    weight: 20,
    target: 90,
    actual: 87,
    lastYearActual: 85,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 19.33
  },
  {
    id: 'obj-cf-3',
    entityId: 'func-finance',
    entityType: 'function',
    perspectiveId: 'internal',
    name: 'Closing Cycle Time',
    weight: 25,
    target: 5,
    actual: 6,
    lastYearActual: 8,
    unit: 'days',
    status: 'at-risk',
    trend: 'up',
    bonus: 20.83
  },
  {
    id: 'obj-cf-4',
    entityId: 'func-finance',
    entityType: 'function',
    perspectiveId: 'learning',
    name: 'Team Certifications',
    weight: 25,
    target: 100,
    actual: 92,
    lastYearActual: 88,
    unit: '%',
    status: 'on-track',
    trend: 'up',
    bonus: 23
  }
];

// KPI Monthly Trends (for charts)
export const mockKPITrends = {
  'comp1': {
    revenue: [
      { month: 'Jan', actual: 28.5, target: 32 },
      { month: 'Feb', actual: 27.8, target: 32 },
      { month: 'Mar', actual: 29.2, target: 32 },
      { month: 'Apr', actual: 26.5, target: 32 },
      { month: 'May', actual: 28.0, target: 32 },
      { month: 'Jun', actual: 31.2, target: 32 },
      { month: 'Jul', actual: 30.8, target: 32 },
      { month: 'Aug', actual: 32.5, target: 32 },
      { month: 'Sep', actual: 33.1, target: 32 },
      { month: 'Oct', actual: 31.8, target: 32 },
      { month: 'Nov', actual: 29.5, target: 32 },
      { month: 'Dec', actual: 29.9, target: 32 }
    ],
    grossProfit: [
      { month: 'Jan', actual: 11.2, target: 12.6 },
      { month: 'Feb', actual: 10.8, target: 12.6 },
      { month: 'Mar', actual: 11.5, target: 12.6 },
      { month: 'Apr', actual: 10.2, target: 12.6 },
      { month: 'May', actual: 11.0, target: 12.6 },
      { month: 'Jun', actual: 12.3, target: 12.6 },
      { month: 'Jul', actual: 12.1, target: 12.6 },
      { month: 'Aug', actual: 12.8, target: 12.6 },
      { month: 'Sep', actual: 13.0, target: 12.6 },
      { month: 'Oct', actual: 12.5, target: 12.6 },
      { month: 'Nov', actual: 11.6, target: 12.6 },
      { month: 'Dec', actual: 12.0, target: 12.6 }
    ]
  }
};

// Dashboard Widget Configurations
export const defaultDashboardWidgets = [
  { id: 'w1', type: 'kpi-card', title: 'Revenue', kpiId: 'revenue', size: 'small', position: { x: 0, y: 0 } },
  { id: 'w2', type: 'kpi-card', title: 'Gross Profit', kpiId: 'grossProfit', size: 'small', position: { x: 1, y: 0 } },
  { id: 'w3', type: 'kpi-card', title: 'Operating Profit', kpiId: 'operatingProfit', size: 'small', position: { x: 2, y: 0 } },
  { id: 'w4', type: 'kpi-card', title: 'Net Profit', kpiId: 'netProfit', size: 'small', position: { x: 3, y: 0 } },
  { id: 'w5', type: 'chart', title: 'Revenue Performance', chartType: 'bar', kpiId: 'revenue', size: 'large', position: { x: 0, y: 1 } },
  { id: 'w6', type: 'gauge', title: 'Achievement %', kpiId: 'overall', size: 'medium', position: { x: 2, y: 1 } },
  { id: 'w7', type: 'pie', title: 'Revenue by Category', kpiId: 'revenueBreakdown', size: 'medium', position: { x: 0, y: 2 } },
  { id: 'w8', type: 'table', title: 'Top KPIs', kpiId: 'topKpis', size: 'large', position: { x: 1, y: 2 } }
];

// Helper function to calculate entity score
export const calculateEntityScore = (entityId, entityType) => {
  const entityObjectives = mockObjectives.filter(
    obj => obj.entityId === entityId && obj.entityType === entityType
  );
  
  if (entityObjectives.length === 0) return 0;
  
  let weightedSum = 0;
  let totalWeight = 0;
  
  entityObjectives.forEach(obj => {
    const achievement = obj.target > 0 ? (obj.actual / obj.target) * 100 : 0;
    weightedSum += achievement * obj.weight;
    totalWeight += obj.weight;
  });
  
  return totalWeight > 0 ? Math.round(weightedSum / totalWeight) : 0;
};

// Helper function to calculate perspective score
export const calculatePerspectiveScore = (entityId, entityType, perspectiveId) => {
  const perspectiveObjectives = mockObjectives.filter(
    obj => obj.entityId === entityId && 
           obj.entityType === entityType && 
           obj.perspectiveId === perspectiveId
  );
  
  if (perspectiveObjectives.length === 0) return 0;
  
  let weightedSum = 0;
  let totalWeight = 0;
  
  perspectiveObjectives.forEach(obj => {
    const achievement = obj.target > 0 ? (obj.actual / obj.target) * 100 : 0;
    weightedSum += achievement * obj.weight;
    totalWeight += obj.weight;
  });
  
  return totalWeight > 0 ? Math.round(weightedSum / totalWeight) : 0;
};

// Get status color
export const getStatusColor = (status) => {
  switch (status) {
    case 'exceeding': return '#10b981';
    case 'on-track': return '#3b82f6';
    case 'at-risk': return '#f59e0b';
    case 'below-target': return '#ef4444';
    case 'critical': return '#dc2626';
    default: return '#6b7280';
  }
};

// Get trend icon direction
export const getTrendDirection = (trend) => {
  switch (trend) {
    case 'up': return 'TrendingUp';
    case 'down': return 'TrendingDown';
    default: return 'Minus';
  }
};
